export default __webpack_public_path__ + "static/media/counterstrike1.871ae9a2.png";